import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { camelCase, includes, isEmpty, map } from "lodash";
import { Collapse, ListGroup, Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { getAppData } from "../../app/environment/environmentSlice";
import { fetchCurrentRoute } from "../Layout/LayoutSlice";

import "../../helpers/fontawesomeLibrary";
import "./styles.css";

const MenuItem = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { menu, currentRoute } = props;
  const { subMenu, icon, label, rootName } = menu;

  const [openMenu, setOpenMenu] = useState(false);
  useEffect(() => {
    if (currentRoute === rootName) {
      setOpenMenu(true);
    }
  }, [rootName, currentRoute]);

  return !isEmpty(subMenu) ? (
    <Nav.Item
      action
      active={currentRoute === rootName}
      as={ListGroup.Item}
      onClick={() => {
        setOpenMenu(!openMenu);
      }}
      aria-controls={`${camelCase(label)}-Menu`}
      aria-expanded={openMenu}
      className={`side-bar--menu ${icon}`}
      key={label}
    >
      {label}
      <span className="caret fa-2x">
        <FontAwesomeIcon icon={["fas", "caret-down"]} size="xs" />
      </span>
      <div>
        <Collapse in={openMenu}>
          <ul id={`${camelCase(label)}-Menu`}>
            {subMenu.map((smenu) => (
              <li
                className={`sub-menu ${
                  includes(smenu.rootMatch, location.pathname) ? "selected" : ""
                }`}
                key={smenu.label}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(smenu.url);
                }}
              >
                <div
                  className={`sub-menu-list-style ${
                    includes(smenu.rootMatch, location.pathname)
                      ? "visible"
                      : "invisible"
                  }`}
                />
                {smenu.label}
              </li>
            ))}
          </ul>
        </Collapse>
      </div>
    </Nav.Item>
  ) : (
    <Nav.Link
      action
      className={`side-bar--menu ${icon}`}
      active={currentRoute === rootName}
      as={ListGroup.Item}
      onClick={() => navigate(rootName)}
      key={label}
    >
      {label}
    </Nav.Link>
  );
};
export function Sidebar(props) {
  const currentRoute = useSelector(fetchCurrentRoute);
  const appData = useSelector(getAppData);
  const { isHeader } = props;
  return (
    <Nav
      as={ListGroup}
      className={`flex-column${isHeader ? "" : " sidebar"}`}
      activeKey={currentRoute}
    >
      {!isEmpty(appData) &&
        appData.tabs.length &&
        map(appData.tabs, (tab) => {
          if (tab.show) {
            return (
              <MenuItem
                key={tab.label}
                menu={tab}
                currentRoute={currentRoute}
              />
            );
          }
        })}
    </Nav>
  );
}
